import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { getCookie } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Components
import Drawer from '../Drawer/Drawer';
import OwedPayments from './OwedPayments';
import UpcomingSessions from './UpcomingSessions';
import PendingSessions from '../Sessions/PendingSessions';
import { Validate } from '../../config.js';
import { isAuthorized } from '@smarterservices/iam-react-client';

const Dashboard = observer(class Dashboard extends React.Component {
  state = {
    drawerOpen: false,
    drawerContent: null,
    messageThreadSid: null
  };

  componentWillMount() {

    const { PaymentStore, ScheduleStore, SessionStore } = this.props.store;
    const { proctorAccountSid } = SessionStore.userData;
    const iam = sessionStorage.getItem('iam');

    let token = null;
    let userData = null;

    if(SessionStore.hasSessionStorage) {
      token = sessionStorage.getItem('token');
      userData = sessionStorage.getItem('userData');
    } else {
      token = getCookie('token');
      userData = getCookie('userData');
    }

    if(token && userData) {
      PaymentStore.getBalance();
      ScheduleStore.getSessions(3, 'Scheduled', null, null, true);
    }
    if(!isAuthorized('sp:DescribeBalance', `ssrn:ss:sp::${proctorAccountSid}:balance`, iam) && 
      isAuthorized('sp:DescribeHybridRooms', `ssrn:ss:sp::${proctorAccountSid}:hybridRoom`, iam)
    ) {
      this.props.routing.history.push('/hybrid-proctoring');
    } else if (!isAuthorized('sp:DescribeBalance', `ssrn:ss:sp::${proctorAccountSid}:balance`, iam) && 
      !isAuthorized('sp:DescribeHybridRooms', `ssrn:ss:sp::${proctorAccountSid}:hybridRoom`, iam)
    ) {
      this.props.routing.history.push('/unauthorized');
    }
  }

  renderResults() {
    const { SessionStore } = this.props.store;

    if(SessionStore.loadingCalls.indexOf('GetBalance') < 0 && SessionStore.loadingCalls.indexOf('GetSessions') < 0) {
      return (
        <ul className="panel-list">
          <li>
            <OwedPayments {...this.props} />
          </li>
          <li>
            <UpcomingSessions {...this.props} />
          </li>
        </ul>
      )
    }

    return '';
  }

  render() {
    const { SessionStore } = this.props.store;
    const { proctorAccountSid } = SessionStore.userData;

    return(
      <Validate>
        <main tabIndex="0" id="main-content" className="page">
          <div className="wrap" iamAction='sp:DescribeBalance' iamResource={`ssrn:ss:sp::${proctorAccountSid}:balance`}>
            <section className="page__section">
              {this.renderResults()}
            </section>

            <section className="page__section">
              <PendingSessions
                parent={this}
                {...this.props}
              />
            </section>
          </div>

          <Drawer
            content={this.state.drawerContent}
            isOpen={this.state.drawerOpen}
            parent={this}
            messageSid={this.state.messageThreadSid}
            pending={true}
            {...this.props}
          />
        </main>
      </Validate>
    )
  }
})

export default translate('Dashboard')(Dashboard);



// WEBPACK FOOTER //
// ./src/app/components/Dashboard/Dashboard.js